import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import { CartProvider } from './component/CartContext';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-toastify';
import { ToastProvider } from './component/ToastContext';
//import { BrowserRouter, Routes, Route } from "react-router-dom";


import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-rtl/dist/css/bootstrap-rtl.min.css';

import './css/App.css';
import './css/Global.css';
import './css/Cart.css';
import "./fontello/css/fontello.css";
import "react-toastify/dist/ReactToastify.css";

import './config';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ToastProvider>
      <CartProvider>
        <App />
      </CartProvider>
      <ToastContainer rtl />
    </ToastProvider>
  </React.StrictMode>
);

reportWebVitals();
